var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 6.00012L4.73509 9.08843C3.10172 9.63288 2 11.1614 2 12.8832V28.4504C2 31.1806 4.67479 33.1085 7.26491 32.2452L14 30.0001L26 34.0001L35.2649 30.9118C36.8983 30.3674 38 28.8388 38 27.1171V11.5498C38 8.81959 35.3252 6.89172 32.7351 7.75509L26 10.0001L14 6.00012ZM27.5 30.3378L34.3162 28.0658C34.7246 27.9297 35 27.5475 35 27.1171V11.5498C35 10.8673 34.3313 10.3853 33.6838 10.6011L26 13.1624L15.5 9.6624V22.0001C15.5 22.8286 14.8284 23.5001 14 23.5001C13.1716 23.5001 12.5 22.8286 12.5 22.0001V9.6624L5.68377 11.9345C5.27543 12.0706 5 12.4527 5 12.8832V28.4504C5 29.133 5.6687 29.6149 6.31623 29.3991L14 26.8378L24.5 30.3378V18.0001C24.5 17.1717 25.1716 16.5001 26 16.5001C26.8284 16.5001 27.5 17.1717 27.5 18.0001V30.3378Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.d67966fa34ba76c9d5dd4b6e40fc8d78.svg";
export { ForwardRef as ReactComponent };